import React from 'react';

import { connect } from 'react-redux';
import { withRouter, RouteComponentProps, Redirect } from 'react-router-dom';

import { userSelector } from '../../reducers/current-user-selectors';

import * as Api from '../../api/api';
import { accountBilling, HOME_ROUTE, orgAdminRoute } from '../../web-routes';

import { LoadingMessage } from '../../widgets/loading-message';

const mapStateToProps = (state: any) => {
  const user = userSelector(state);
  return {
    user,
  };
};

type InputProps = {
  queryParams: {
    sessionId?: string;
    accountId?: number;
    orgId?: number;
  };
};

type ReduxProps = ReturnType<typeof mapStateToProps>;
type Props = InputProps & ReduxProps & RouteComponentProps;

export const CheckoutSessionCompletedRedirect = withRouter(
  connect(mapStateToProps)((props: Props) => {
    const { user, queryParams, history } = props;
    const { accountId, orgId, sessionId } = queryParams;

    if (!user || !queryParams.accountId) {
      return <Redirect to={HOME_ROUTE} />;
    }

    Api.post(`/account/${accountId}/process-completed-checkout-session`, {
      body: JSON.stringify({ stripeSessionId: sessionId }),
    })
      .then((response) => response.json())
      .finally(() => {
        let redirectRoute = accountBilling(accountId);
        if (user.isAdmin && orgId) {
          redirectRoute = orgAdminRoute(orgId) + redirectRoute;
        }
        history.push(redirectRoute);
      });

    return <LoadingMessage />;
  }),
);
